import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import VCategoriesList from 'containers/pages/ultraVouchers/categories/List'
import VCategoriesForm from 'containers/pages/ultraVouchers/categories/Form'

const Categories = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/ultra-vouchers/categories') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-vouchervoucher-category-read') > -1) {
      return <VCategoriesList location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('edit') || location.pathname.includes('add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-vouchervoucher-category-write') > -1) {
      return <VCategoriesForm location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

Categories.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Categories
